import useI18n from "@/hooks/useI18n";

export interface Plan {
  id: string;
  name: string;
  isBestSeller?: boolean;
  promo?: string;
  originalPrice?: string;
  price: string;
  pricePeriod?: string;
  tags?: string[];
  regulationLink?: string;
}


export default function PlanSelection() {
  const { t } = useI18n();

  const plans: Plan[] = [
    {
        id: "livre",
        name: "Livre",
        promo: "Pré-pago",
        originalPrice: "Recarregue e use",
        price: "Sem mensalidade",
        tags: ["Frete grátis"],
        regulationLink: 'http://semparar.com.br/planos-free-flow'
      },
    {
        id: "completo",
        name: "Completo",
        isBestSeller: true,
        promo: "91% OFF por 10 meses",
        originalPrice: "De R$59,90 por",
        price: "R$4,90",
        pricePeriod: "/mês até o 10º mês",
        tags: ["Assistências inclusas", "Frete grátis"],
        regulationLink: 'http://semparar.com.br/planos-free-flow'
      },
    {
      id: "classico",
      name: "Clássico",
      promo: "92% OFF por 10 meses",
      originalPrice: "De R$39,90 por",
      price: "R$2,90",
      pricePeriod: "/mês até o 10º mês",
      tags: ["Economize R$370", "Frete grátis"],
      regulationLink: 'http://semparar.com.br/planos-free-flow'
    },
    {
      id: "flex",
      name: "Flex",
      promo: "Não usa, não paga!",
      originalPrice: "De R$25,90 por",
      price: "R$18,90",
      pricePeriod: "/mês que usar",
      tags: ["Frete grátis"],
      regulationLink: 'http://semparar.com.br/planos-free-flow'
    }
  ];


  return (
    <div className="w-full">
      <div className="text-left md:text-center mb-6 px-2 md:px-0">
        <p className="text-sm md:text-base text-black font-normal leading-relaxed">
          {t("pages:success:choosePlan")}
          <span className="font-bold text-principal"> tag Sem Parar</span>
          <strong>{t("pages:success:choosePlanSuffix")}</strong>
        </p>
      </div>

      <div className="flex gap-3 md:gap-4 overflow-x-auto pb-4 -mx-4 px-4 md:overflow-x-visible md:-mx-0 md:px-0 md:justify-center snap-x snap-mandatory md:snap-none">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className="min-w-[260px] md:min-w-[280px] max-w-[260px] md:max-w-[340px] rounded-[15px] flex-shrink-0 flex flex-col relative snap-center"
            style={plan.isBestSeller ? {
              background: 'linear-gradient(to bottom, #d60b52 0%, rgba(214, 11, 82, 0.8) 20%, rgba(214, 11, 82, 0.5) 40%, rgba(214, 11, 82, 0.2) 60%, transparent 100%)',
            } : {
              background: 'white',
            }}
          >
            <div 
              className={`bg-white rounded-[14px] flex-1 flex flex-col relative z-10`}
              style={plan.isBestSeller ? {
                position: 'absolute',
                top: '1px',
                left: '1px',
                right: '1px',
              } : {border: '1px solid #E6E6E6'}}
            >
            <div className="p-3 md:p-4 pb-3 relative z-10 border-b border-gray-100">
              <div className="flex items-start justify-between gap-2">
                <p className="text-lg md:text-xl font-bold text-black leading-tight">{plan.name}</p>
                {plan.isBestSeller && (
                  <span className="bg-principal text-white text-[10px] md:text-xs font-semibold px-2 md:px-3 py-1 md:py-1.5 rounded-md whitespace-nowrap flex-shrink-0">
                    {t("pages:success:bestSeller")}
                  </span>
                )}
              </div>
            </div>

            <div className="pt-4 md:pt-6 px-3 md:px-4 flex-1 flex flex-col relative z-10">
              {plan.promo && (
                <h3 className="text-sm md:text-base font-semibold text-[#0E0D0D] mb-2 leading-tight">{plan.promo}</h3>
              )}

              {plan.originalPrice && (
                <p className="text-xs md:text-sm text-gray-500 mb-2">
                    {plan.originalPrice}              
                </p>
              )}

              <div className="flex items-baseline gap-1 mb-3">
                <span className="text-2xl md:text-3xl font-bold text-black leading-none">{plan.price}</span>
                {plan.pricePeriod && (
                  <span className="text-xs md:text-sm text-black ml-1">{plan.pricePeriod}</span>
                )}
              </div>

              {plan.tags && plan.tags.length > 0 && (
                <ul className="flex flex-wrap gap-1.5 md:gap-2 mb-4">
                  {plan.tags.map((tag, index) => (
                    <li
                      key={index}
                      className="text-[10px] md:text-xs text-white bg-[#363636] px-2 md:px-3 py-0.5 md:py-1 rounded-md font-medium"
                    >
                      {tag}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="px-3 md:px-4 pb-3 md:pb-4 pt-3 md:pt-4 relative z-10 border-t border-gray-100 bg-[#f9f9f9] rounded-bl-[14px] rounded-br-[14px]">
              <a
                href={plan.regulationLink}
                target="_new"
                className="w-full text-xs md:text-sm text-gray-500 flex items-center justify-between hover:text-black transition-colors"
              >
                <span>{t("pages:success:viewPlanDetails")}</span>
                <svg className="w-3.5 md:w-4 h-3.5 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

